import { css } from '@emotion/css';
import { m, mobileMediaQuery, p2Css } from '@snapchat/snap-design-system-marketing';

export const successLogoCss = css`
  position: absolute;
  left: 50%;
  top: 200px;
  transform: translate(-50%, -50%);
  height: 100px;
  width: 100px;
  z-index: 1;
`;

export const successBlockCss = css`
  /* Target the actual background image element, not CSS background */
  & > span {
    picture,
    img {
      object-position: top center;
    }
  }

  /* Push down title and contents */
  & .sdsm-block-boundary {
    padding-top: 250px;
  }

  & [data-testid='sdsm-block-title'] h2 {
    /* Remove default capitalization */
    text-transform: none;
  }

  & [data-testid='sdsm-block-subtitle'] p {
    ${p2Css}
    margin-bottom: 30px;
  }

  /* Apply border-radius to all Content components */
  & .sdsm-content {
    border-radius: 8px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    transition: transform 0.2s ease;

    /* Hide the CTA button visually - we are converting the entire Content into a link */
    & [data-testid='sdsm-content-cta'] {
      /* Negative margin to collapse the gap above it */
      margin-top: calc(-1 * ${m('--spacing-xl')});

      /* Target the actual link/button element */
      & a,
      & button {
        opacity: 0;
        position: absolute;
        inset: 0;
        z-index: 10;
        cursor: pointer;

        /* Reset all button/link styling */
        background: none;
        border: none;
        box-shadow: none;
        padding: 0;
        margin: 0;
        color: transparent;
        text-decoration: none;

        /* Ensure it fills the space */
        width: 100%;
        height: 100%;
        display: block;
      }
    }

    /* Hover effect for the card */
    &:hover {
      transform: translateY(-2px);
    }
  }

  /* Reduce gap between title and body for all Content components */
  & [data-testid='sdsm-content-header-and-body'] {
    gap: ${m('--spacing-xxs')};
  }

  /* Target the first Content component within the Block */
  & .sdsm-content:nth-of-type(1) {
    background: linear-gradient(270deg, rgba(255, 240, 185, 0.4) 0%, rgba(255, 207, 244, 0.4) 100%);
    border: 1px solid;
    border-image-source: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.2) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  }

  /* Target the second Content component */
  & .sdsm-content:nth-of-type(2) {
    background: linear-gradient(270deg, rgba(255, 240, 185, 0.2) 0%, rgba(255, 207, 244, 0.2) 100%);
    border: 1px solid;
    border-image-source: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.2) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  }

  /* Target the last Content component  - should have smaller title and body font sizes */
  & .sdsm-content:last-of-type {
    background: linear-gradient(270deg, rgba(255, 240, 185, 0.2) 0%, rgba(255, 207, 244, 0.2) 100%);

    /* Reduce top and bottom padding to --spacing-m */
    padding-top: ${m('--spacing-m')};
    padding-bottom: ${m('--spacing-m')};

    /* Change title to H6 size (18px) */
    & [data-testid='sdsm-content-title'] {
      font-size: ${m('--h6-desktop-font-size')};
      line-height: ${m('--h6-desktop-font-line-height')};

      ${mobileMediaQuery} {
        font-size: ${m('--h6-mobile-font-size')};
        line-height: ${m('--h6-mobile-font-line-height')};
      }
    }

    /* Change body to P3 (14px) */
    & .sdsm-content-body {
      font-size: ${m('--p3-desktop-font-size')};
      line-height: ${m('--p3-desktop-font-line-height')};

      ${mobileMediaQuery} {
        font-size: ${m('--p3-mobile-font-size')};
        line-height: ${m('--p3-mobile-font-line-height')};
      }
    }
  }
`;
